import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const onwardPlacementForm: Form<Client> = {
  key: 'onwardPlacementForm',
  title: 'Weitervermittlung',
  fields: [
    {
      key: 'onwardPlacement',
      label: 'Weitervermittlung',
      fieldTypes: 'checkboxSelect',
      xsWidth: 12,
      options: [
        { value: 'WomensCounseling', label: 'Frauennotruf' },
        { value: 'womensShelter', label: 'Frauenhaus' },
        { value: 'lawyer', label: 'Rechtsanwält*innen' },
        { value: 'police', label: 'Polizei' },
        { value: 'forensicMedicine', label: 'Rechtsmedizin' },
        { value: 'localCourt', label: 'Rechtsantragsstelle/ Amtsgericht' },
        { value: 'youthWelfareOffice', label: 'Jugendamt' },
        { value: 'socialBenefitProvider', label: 'Sozialleistungsträger' },
        { value: 'healthcare', label: 'Gesundheitswesen' },
        { value: 'addictionCounseling', label: 'Suchtberatung' },
        { value: 'marriageFamilyLifeCounseling', label: 'Ehe-, Fam-, u. Lebensberatung' },
        { value: 'therapist', label: 'Therapeut*in' },
        { value: 'educationalCounseling', label: 'Erziehungsberatung' },
        { value: 'helpline', label: 'Hilfetelefon' },
        { value: 'crisisService', label: 'Krisendienst' },
        { value: 'socialPsychiatricService', label: 'SpDi' },
        { value: 'itCounseling', label: 'IT-Beratung' },
        { value: 'counselingCenter', label: 'Fachber. Für Opfer von Menschenhandel, Zwangsprost. U. Zwangsheirat' },
        { value: 'other', label: 'Sonstiges' },
      ],
    },
    {
      key: 'otherOnwardPlacement',
      label: 'Sonstige Weitervermittlung',
      fieldTypes: 'text',
      xsWidth: 12,
      isVisible: (client) => client.onwardPlacement != null && client.onwardPlacement.includes('other'),
    },
    {
      key: 'onwardPlacementDirectContact',
      label: 'direkte Kontaktaufnahme',
      fieldTypes: 'checkbox',
    },
  ],
};

export default onwardPlacementForm;
